import { CoverageItem } from "./formikData";
import { IPlan, PlanType } from "./productInfoInterfaces";
import { Sex } from "./quoteInterfaces";
import { isNumberValue } from "@/common/utils/helpers";

export const areAllPolicyRiderFieldsPresent = (policyRider: CoverageItem): any => {
  const policyRiderInfo = policyRider?.payorDisabilityWaiverOfPremiumRiderInfo;
  const result =
    isNumberValue(policyRiderInfo?.age) &&
    (policyRiderInfo?.sex === Sex.Male || policyRiderInfo?.sex === Sex.Female) &&
    typeof (policyRiderInfo?.isSmoker) === "boolean";

  return result;
};

export const isFaceAmountProvidedForEditRider = (editRider: CoverageItem): any => {
  const result = editRider.uiHint === null || isNumberValue(editRider.faceAmount);

  return result;
};

export const isBasePlan = (plan: IPlan): boolean => {
  const result = plan?.planType === PlanType.BasePlan;

  return result;
};

